import { PERMISSIONS } from '../../constants';
import BolaoList from './BolaoList';
import BolaoCreate from './BolaoCreate';
import BolaoEdit from './BolaoEdit';
import BolaoShow from './BolaoShow';

export default {
  list: BolaoList,
  create: BolaoCreate,
  edit: BolaoEdit,
  show: BolaoShow,
  name: 'boloes',
  permissions: [PERMISSIONS.GIFT],
  options: { label: 'Bolões' },
};
